// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1ZOFx","calendarButtons":"ClockData_calendarButtons__2bHbD"};